/* eslint-disable camelcase */
import {WixSdk} from 'js-sdk-wrapper';
import {sendRequest} from 'music-shared/dist/src/utils/send-request';
import {BI_ERRORS} from '../logging/errors';
import {logError} from '../logging/logging';
import {subscribeToEmitter} from './subscribe-to-emitter';

export function logToCounters(statisticsEvents, {siteOwnerId}) {
  const events = {
    trackPlayStart: {
      type: 'song',
      name: 'play',
      params: baseTrackData
    },
    trackSkipped: {
      type: 'song',
      name: 'skip',
      params: baseTrackData
    },
    trackPlayCompleted: {
      type: 'song',
      name: 'completed',
      params: baseTrackData
    },
    trackShareClicked: {
      type: 'song',
      name: 'share',
      params: args => ({
        ...baseTrackData(args),
        social: args.network
      })
    },

    albumShareClicked: {
      type: 'album',
      name: 'share',
      params: args => ({
        ...baseAlbumData(args),
        social: args.network
      })
    }
  };

  subscribeToEmitter(statisticsEvents, events, send);

  function send(eventName, eventDescription, eventArgs) {
    const viewMode = WixSdk.Utils.getViewMode();
    if (viewMode === 'editor' || viewMode === 'preview') {
      return;
    }

    const data = {
      messageId: Date.now(),
      metrics: [{
        type: eventDescription.type,
        reportMetrics: [{
          name: eventDescription.name,
          value: 1
        }],
        properties: {
          user_id: siteOwnerId,
          ...eventDescription.params(eventArgs)
        }
      }]
    };
    sendReport(data);
  }

  function baseAlbumData({album}) {
    return {
      album_id: album.id,
      album_type: album.albumType
    };
  }

  function baseTrackData(args) {
    return {
      ...baseAlbumData(args),
      song_id: String(args.track.id)
    };
  }
}

function sendReport(data) {
  let ctToken;
  WixSdk.SuperApps.getCtToken()
    .then(_ctToken => {
      ctToken = _ctToken;
      if (!ctToken) {
        logError(BI_ERRORS.widget.statistic.counters.emptyCtToken);
      }
      return sendRequest({
        method: 'POST',
        url: '//player-counters.wix.com/collector/rest/collect-js',
        params: {ctToken},
        data
      });
    })
    .catch(reason => {
      let userAgent = 'unknown';
      try {
        userAgent = navigator.userAgent;
      } finally {
        logError(BI_ERRORS.widget.statistic.counters.send, {reason, ctToken, userAgent});
      }
    });
}





// WEBPACK FOOTER //
// ./statistics/counters.ts